import type { PageLoad } from './$types';

export const load: PageLoad = () => {
  return {
    meta: {
      title: 'Courses',
      activeNav: 'courses',
      breadcrumbs: {
        activeTitle: 'Courses & Skills',
        items: [],
      },
    },
  };
};
